import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { HubPayload } from '@aws-amplify/core/lib/Hub';
import { LoaderService } from '../_services/loader.service';
import { Hub } from 'aws-amplify';
import { AmplifyService } from 'aws-amplify-angular';
import { Router } from '@angular/router';
import { ProductoService } from '../_services/producto.service';




@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html'
})
export class AuthorizeComponent implements OnInit {

  mostrarError = false;
  datosSignup: any;

  constructor(private authenticationService: AuthenticationService,
    private amplifyService: AmplifyService,
    private loaderService: LoaderService,
    private productoService: ProductoService,
    private router: Router) {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      this.ngValidateUser(payload);
    });
  }

  ngOnInit(): void {
    this.loaderService.show();
  }

  ngValidateUser(payload: HubPayload) {
    if (payload.event == 'cognitoHostedUI') {
      this.checkUser();
    }
  }

  checkUser() {
    const auth: any = this.amplifyService.auth();
    const loginParams = this.productoService.getLoginParams();
    auth.currentAuthenticatedUser().then(user => {
      this.authenticationService.signUpExterno(user.keyPrefix + '.' + user.username).subscribe(data => {
          this.LoginUsuarioExterno(user, loginParams);
        }, error => {
          this.loaderService.hide();
          this.router.navigate(['/error']);
        });
    });
  }

  private LoginUsuarioExterno(user: any, loginParams: any) {
    this.authenticationService.loginExterno(user.keyPrefix + '.' + user.username, loginParams.idAplicacion, loginParams.filtroAdicional).subscribe(data => {
      this.authenticationService.redirectUsuarioLogeado(data, loginParams.redirectUsuarioLogeado);
    }, error => {
      this.loaderService.hide();
      this.loaderService.hide();
      this.router.navigate(['/error']);
    });
  }
}
